module.exports = __webpack_public_path__ + "static/Regulamin-promocja-ORLENCharge-3-cykl-pl-a7f5fdf73332786022745b5afcbe681a.pdf";